import httpClient from './httpClient'

const END_POINT = '/api/dias'

const getAllDias = () => httpClient.get(END_POINT)

export {

    getAllDias

}